import React, { useState, useEffect } from 'react';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseURL } from '../../../../globalUtils/axiosConfig';
import AttachmentContainer from "./AttachmentContainter";

const DeliveryNotesList = ({ 
  materialControlRegisterId, 
  progressStepType = 'qc_release',
  maxDisplay = null,
  onCountChange,
  onUpdate,
  color,
  projectId
}) => {
  const navigate = useNavigate();
  const [deliveryNotes, setDeliveryNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (materialControlRegisterId) {
      fetchDeliveryNotes();
    }
  }, [materialControlRegisterId, progressStepType]);

  const fetchDeliveryNotes = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.get(
        `${baseURL}/delivery-notes?materialControlRegisterId=${materialControlRegisterId}&progressStepType=${progressStepType}`
      );
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        // Filter by progressStepType
        const filteredNotes = response.data.data.filter(
          note => note.progressStepType === progressStepType
        );
        setDeliveryNotes(filteredNotes);
        setTotalCount(response.data.total || filteredNotes.length);
        if (onCountChange) {
          onCountChange(filteredNotes.length);
        }
      } else {
        setDeliveryNotes([]);
        setTotalCount(0);
        if (onCountChange) {
          onCountChange(0);
        }
      }
    } catch (err) {
      console.error('Error fetching delivery notes:', err);
      setError('Failed to load delivery notes');
      message.error('Failed to load delivery notes');
      setDeliveryNotes([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '20px' }}>
        <Spin size="small" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ color: '#ff4d4f', fontSize: '12px' }}>
        {error}
      </div>
    );
  }

//   if (!deliveryNotes || deliveryNotes.length === 0) {
//     // return (
//     //   <div style={{ color: '#8c8c8c', fontSize: '12px', fontStyle: 'italic' }}>
//     //   </div>
//     // );
//   }

  const displayNotes = maxDisplay ? deliveryNotes.slice(0, maxDisplay) : deliveryNotes;
  const hasMore = maxDisplay && deliveryNotes.length > maxDisplay;
  const shouldShowMore = totalCount > 10;

  // Collect all attachments from delivery notes
  const allAttachments = deliveryNotes.reduce((acc, note) => {
    if (note.attachments && Array.isArray(note.attachments)) {
      return [...acc, ...note.attachments];
    }
    return acc;
  }, []);

  const handleShowMoreClick = () => {
    if (projectId) {
      navigate(`/project/delivery-notes/${projectId}`);
    }
  };

  return (
    <div className="delivery-notes-list">
      {displayNotes.map((note, index) => (
        <div key={note.id || index} className="delivery-note-item">
          <span className="delivery-note-number">
            {note.delNoteNo || note.deliveryNoteNumber || `DN-${note.id}`}
          </span>
        </div>
      ))}
      {hasMore && (
        <div className="delivery-notes-more">
          +{deliveryNotes.length - maxDisplay} Show more
        </div>
      )}
      {shouldShowMore && (
        <div 
          className="delivery-notes-show-more" 
          onClick={handleShowMoreClick}
          style={{
            cursor: 'pointer',
            color: '#808080',
            fontSize: '11px',
            marginTop: '4px',
            fontStyle: 'italic'
          }}
        >
          Show More
        </div>
      )}
      <AttachmentContainer
        color={color}
        recordType={progressStepType}
        record={{ 
          id: materialControlRegisterId,
          attachments: allAttachments
        }}
        useShippingIcon={true}
        onUpdate={onUpdate}
      />
    </div>
  );
};

export default DeliveryNotesList;
